import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function doLogin(data){
    return request({
        url:Api.user.login,
        method:configs.http.request.methodPost,
        data
    })
}


export function getUserList(data){
    return request({
        url:Api.user.list,
        method:configs.http.request.methodGet,
        data
    })
}

export function exportUserList(data){
    return request({
        url:Api.user.export,
        method:configs.http.request.methodGet,
        data
    })
}


export function CreateUser(data){
    return request({
        url:Api.user.create,
        method:configs.http.request.methodPost,
        data
    })
}

export function ResetPasswd(data){
    return request({
        url:Api.user.reset+data.id,
        method:configs.http.request.methodPut,
        data
    })
}


export function disableUser(data) {
    return request({
        url:Api.user.delete+data.id,
        method:configs.http.request.methodDelete,
        data
    })
}

export function bindGroup(data) {
    return request({
        url:Api.user.bind_group,
        method:configs.http.request.methodPost,
        data
    })
}
